import get from 'lodash/get'
import React from 'react'

import { detailReportSlice } from '../../corporate-income-tax-report-container/store'
import { xCoordinatesPeriod12, xCoordinatesReport12, yCoordinatesPeriod12 } from '../common-report/const'
import { FormData } from '../common-report/form-data'
import { getPeriod, getReportGrid } from '../common-report/helper'
import { SvgFormWrapper } from '../common-report/styles'
import reportBackground from './background.svg'

export const ReportForm = () => {
  const cellWidth = 93
  const yCoordinate = 89
  const heightPerRow: number[] = [
    18.5, 18.5, 18.5, 19, 19, 19, 21, 22, 21, 21, 21, 20, 21, 21, 21, 21, 20, 22, 22, 19, 20, 18.5, 18.5, 23, 23, 18.5,
    19, 19, 19, 21, 20.5, 21, 20.5, 21, 21, 21, 20, 21, 21, 21, 20.5, 21, 20.5, 21, 21, 20.5, 27,
  ]

  const reportData = detailReportSlice.useSlice(state => state?.data)

  const propsData = {
    reportData: getReportGrid(heightPerRow, cellWidth, xCoordinatesReport12, yCoordinate, reportData),
    reportPeriods: getPeriod(reportData, xCoordinatesPeriod12, yCoordinatesPeriod12),
    companyName: { x: 575, y: 40, w: 174, h: 49, value: get(reportData, 'office_name', '') },
    reportBackground,
  }

  return (
    <SvgFormWrapper>
      <FormData {...propsData} />
    </SvgFormWrapper>
  )
}
